'use client';

import ReactDOM from 'react-dom';
import { CONFIG } from '@frameio/config';

export function Preconnects() {
  ReactDOM.preconnect(CONFIG.massdriverOrigin);
  ReactDOM.preconnect(CONFIG.pictureOrigin);
  ReactDOM.preconnect(CONFIG.assetsOrigin);

  return null;
}
